import * as O from "fp-ts/Option";
import { PendingData } from "lib/at-data/AsyncData";
import { ActivityLiveOccupancyState } from "controllers/AssetLiveOccupancyController/state";

export const initialState: ActivityLiveOccupancyState = {
  lastOccupancyEstimate: PendingData(O.none),
};
